import { render, staticRenderFns } from "./TariffBuyCertificates.vue?vue&type=template&id=859e975c&scoped=true"
import script from "./TariffBuyCertificates.vue?vue&type=script&lang=js"
export * from "./TariffBuyCertificates.vue?vue&type=script&lang=js"
import style0 from "./TariffBuyCertificates.vue?vue&type=style&index=0&id=859e975c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859e975c",
  null
  
)

export default component.exports